/**
 * 面对面赠券
 */
export const FACECOUPON_MEMBER_SEARCH = {
  name: '面对面赠券—查询会员',
  api: '${FACE2FACE}/app-face/api/D/external/customer/info',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#9a8ee16256f576474ec24d0860ea6b94',
};
export const FACECOUPON_LIST = {
  name: '面对面赠券—券批列表',
  api: '${FACE2FACE}/app-face/app/coupon/list',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#56dd9434fd982a153e4e55339456e998',
};
export const FACECOUPON_GET_MORE = {
  name: '面对面赠券—领多张券',
  api: '${FACE2FACE}/app-face/app/coupon/get/more',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#f4ac4502dcd0e0595095e589889fc41d',
};


